import { render, staticRenderFns } from "./aboutCompany.vue?vue&type=template&id=7bbee7eb&scoped=true&"
import script from "./aboutCompany.vue?vue&type=script&lang=js&"
export * from "./aboutCompany.vue?vue&type=script&lang=js&"
import style0 from "./aboutCompany.vue?vue&type=style&index=0&id=7bbee7eb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bbee7eb",
  null
  
)

export default component.exports